/* src/app/modules/shared/components/header-column/header-column-wrapper/header-column-wrapper.component.scss */
app-header-column-wrapper {
  display: contents;
}
/*# sourceMappingURL=header-column-wrapper.component.css.map */
